<div class="app-shell">
  <router-outlet></router-outlet>
  @if (showFooter()) {
    <app-app-footer></app-app-footer>
  }
</div>
